/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import $ from 'jquery';
import TagManager from 'react-gtm-module';
import MetaTags from 'react-meta-tags';
// install Swiper modules
SwiperCore.use([Pagination, Autoplay]);

function Caption01() {
	const tagManagerArgs = {
		gtmId: 'GTM-NDBLPCX'
	}
	TagManager.initialize(tagManagerArgs);

	const pagination = {
		clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + "</span>";
    }
	};
	
	let location = useLocation();
	useEffect(() => {
		$(".btn_popup").on('click', function () {
			$(".popup").hide();
			var href = "#" + $(this).attr('id');
			$(href).show();
		})
		$(".btn_close").on('click', function () {
			$(".popup").hide();
		});
	}, [location])

	return (
		<>
			<MetaTags>
				<title>中華電信i寶貝智慧音箱-服務說明</title>
				<meta name="keywords" content="i寶貝服務說明,聲控服務,智慧助理,生活助理,聲控家電,智慧家庭,歌曲清單,音樂故事,聲音內容,情境模式"></meta>
				<meta name="description" content="中華電信i寶貝智慧聲控服務內容相當多元。包含天氣、股市、訂定鬧鐘與待辦事項…等，當您的貼心智慧小幫手。也可從i寶貝智慧音箱聽Podcast、歌曲、故事、相聲…等，各式各樣的聲音內容來豐富自己。更可將自家的智慧家電設備綁定後匯入，享受聲控的方便性。=當您回到家、離開家時，也能一句話控制家裡多數的家電哦！目前可支援的家電品牌：LG、大同、Panasonic、艾法。" />
				<meta property="og:title" content="中華電信i寶貝智慧音箱-服務說明" />
				<meta property="og:Description" content="中華電信i寶貝智慧聲控服務內容相當多元。包含天氣、股市、訂定鬧鐘與待辦事項…等，當您的貼心智慧小幫手。也可從i寶貝智慧音箱聽Podcast、歌曲、故事、相聲…等，各式各樣的聲音內容來豐富自己。更可將自家的智慧家電設備綁定後匯入，享受聲控的方便性。=當您回到家、離開家時，也能一句話控制家裡多數的家電哦！目前可支援的家電品牌：LG、大同、Panasonic、艾法。" />
				<meta property="og:image" content="https://ibobby.ai.hinet.net/app_icons/app_banner/imgUpload_496bf11d-5c35-41c7-b18c-894e7331f961.png" />
			</MetaTags>
			<div className="popup" id="cb_pop01">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">生活助理</div>
								<h4 className="cb_01">i寶貝智慧聲控服務</h4>
								<p>「i寶貝智慧聲控服務」是中華電信積極投入打造的一個語音助理串聯應用的平台，提供「語音辨識」及「語意分析」等服務，除自己的技術外，中華電信規畫攜手合作夥伴，將語音辨識應用在不同的服務場域。</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，明天台北天氣如何?</span></p></li>
									<li><p><span>i寶貝，明天板橋要帶傘嗎?</span></p></li>
									<li><p><span>i寶貝，新北出門要擦防曬乳嗎?</span></p></li>
									<li><p><span>i寶貝，1-2+3-4+5等於多少?</span></p></li>
									<li><p><span>i寶貝，除夕是幾月幾號?</span></p></li>
									<li><p><span>i寶貝，紐約和台北時差幾個小時?</span></p></li>
									<li><p><span>i寶貝，講個笑話來聽</span></p></li>
									<li><p><span>i寶貝，美金換台幣匯率多少?</span></p></li>
									<li><p><span>i寶貝，我要查高鐵</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop40">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">生活助理</div>
								<h4 className="cb_40">聲控兌品</h4>
								<p>•i寶貝智慧音箱提供聲控兌換Hami市集商品，免出門就可輕鬆補給數十種日常用品。</p>
							<p>•活動期間免運費快來使用喔。</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，我有多少點數</span></p></li>
									<li><p><span>i寶貝，我可以換什麼商品</span></p></li>
									<li><p><span>i寶貝，我要換衛生紙</span></p></li>
									<li><p><span>i寶貝，要在哪查詢物流進度</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop41">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">生活助理</div>
								<h4 className="cb_41">本月新星</h4>
								<p>想了解 i寶貝最新上線的技能嗎? 快對音箱說「召喚本月新星」，讓i寶貝告訴您最近學會的新技能~</p>
						  		<div></div><br />
								<p>註：提醒您，當進入「本月新星」後將暫時無法使用其他服務(如聽音樂、故事…)及功能，如要離開請說「離開本月新星」。</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，召喚本月新星</span></p></li>
									<li><p><span>i寶貝，最近有什麼新功能?</span></p></li>
									<li><p><span>i寶貝，[新功能名稱]是什麼?</span></p></li>
									<li><p><span>i寶貝，離開本月新星</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop03">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">生活助理</div>
								<h4 className="cb_03">我要說悄悄話</h4>
								<p>有太多悄悄話想說給某人聽，卻不敢說、不好意思說、一次說不完？快跟i寶貝說「我要說悄悄話」，讓i寶貝幫您錄下10秒鐘想說的話，讓您不再「想在心裡口難開」！</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，我要說悄悄話</span></p></li>
									<li><p><span>i寶貝，我要錄音</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		
			<div className="popup" id="cb_pop37">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">生活助理</div>
								<h4 className="cb_37">整點報時</h4>
								<p>您是否會因工務繁忙，忙到忘記吃飯、喝水? 整點報時功能可以讓您更有效率的利用時間， 當您選擇完欲報時的整點時段，i寶貝可於指定時間播放「現在時間X點整」，讓i寶貝陪伴忙碌的你更有效率掌控生活大小事！</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>提供整點報時資訊(於指定時間播放「現在時間X點整」)</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop36">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">生活助理</div>
								<h4 className="cb_36">日程表</h4>
								<p>可透過聲控或從app設定鬧鐘、待辦事項、貼心提醒、每日必聽在日程表上，未來亦會持續推出新功能，讓您享受最便利的智慧生活。</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，今天的日程表有甚麼?</span></p></li>
									<li><p><span>i寶貝，今天我有哪些待辦事項</span></p></li>
									<li><p><span>i寶貝，幫我設定明天早上7點的鬧鐘</span></p></li>
									<li><p><span>i寶貝，我明天有哪些鬧鐘</span></p></li>
									<li><p><span>i寶貝，刪除明天早上7點的鬧鐘</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop08">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">生活助理</div>
								<h4 className="cb_08">天氣小幫手</h4>
								<p>不知道今天出門該怎麼穿？問i寶貝就對了！「天氣小幫手」提供您天氣預報與即時資訊查詢，包含天氣、溫度、紫外線、空氣品質、降雨機率、颱風假等資訊。</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，明天台北天氣如何</span></p></li>
									<li><p><span>i寶貝，淡水今天要擦防曬乳嗎</span></p></li>
									<li><p><span>i寶貝，板橋明天要帶傘嗎</span></p></li>
									<li><p><span>i寶貝，台中今天的空氣品質</span></p></li>
									<li><p><span>i寶貝，明天台東有放颱風假嗎</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop09">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">生活助理</div>
								<h4 className="cb_09">時間小幫手</h4>
								<p>i寶貝可以「查時間日期、查節日、查各大城市時間、查時區時差、農曆時間」，讓您不再錯過重要節日、時差再也不是問題！</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，紐約和台北時差幾小時</span></p></li>
									<li><p><span>i寶貝，多倫多現在幾點</span></p></li>
									<li><p><span>i寶貝，今天是農曆幾月幾號</span></p></li>
									<li><p><span>i寶貝，情人節是什麼時候</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop10">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">生活助理</div>
								<h4 className="cb_10">算數小幫手</h4>
								<p>四則運算都考不倒i寶貝！</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，1+2x3等於多少</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop11">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">生活助理</div>
								<h4 className="cb_11">說笑話達人</h4>
								<p>讓i寶貝講個笑話你聽，為你帶來一天的好心情！</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，我要聽笑話</span></p></li>
									<li><p><span>i寶貝，說個笑話來聽聽</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop12">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">生活助理</div>
								<h4 className="cb_12">1288</h4>
								<p>「中華電信1288服務」提供有28大類、2180個行業別，總計57萬筆工商店家查號服務。要找餐廳？問i寶貝就對了！</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，幫我找101附近的餐廳</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop13">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">生活助理</div>
								<h4 className="cb_13">維基百科</h4>
								<p>維基百科是全球網路上最大且最受大眾歡迎的參考工具書，名列全球十大最受歡迎的網站，現在已可透過i寶貝進行語音搜尋囉！</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，周杰倫是誰</span></p></li>
									<li><p><span>i寶貝，原子彈是什麼</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop14">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">生活助理</div>
								<h4 className="cb_14">三竹股市</h4>
								<p>語音查詢各別股票名稱、代號、價位、成交量。</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，中華電信股票多少</span></p></li>
									<li><p><span>i寶貝，2412現在漲還是跌</span></p></li>
									<li><p><span>i寶貝，大盤今天成交價</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop15">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">生活助理</div>
								<h4 className="cb_15">匯率查詢</h4>
								<p>語音查詢台灣銀行提供的外幣匯率。</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，美金現在匯率多少</span></p></li>
									<li><p><span>i寶貝，1日幣可以換多少台幣</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div className="popup" id="cb_pop18">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">生活助理</div>
								<h4 className="cb_18">查高鐵</h4>
								<p>語音搜尋高鐵班次。</p>
								<p>(高鐵班次資料介接:交通部PTX平台)<img style={{ display: "inline", height: "35px" }} src={require("../../image/icon_cb_38.png").default} alt="icon_cb_38" /></p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，我要查高鐵</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop33">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">生活助理</div>
								<h4 className="cb_33">台語字典</h4>
								<p>想變成台語達人嗎？快跟i寶貝一起學台語！</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，長頸鹿台語怎麼說</span></p></li>
									<li><p><span>i寶貝，冷氣的台語</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div className="content_inpage">
				<div className="pagesize">
					<ul className="bread">
						<li><a href="/">首頁</a></li>
						<li><a href="/container/caption">服務說明</a></li>
					</ul>
					<div className="tab_con">
						<div className="tab_box active">
							<h2 className="tit_main">服務說明 - 生活助理</h2>
							<div className="content_box caption_box">
								<Swiper
									spaceBetween={50}
									pagination={pagination}
									autoplay={{
										"delay": 5000,
										"disableOnInteraction": false
									}}
								>
									<SwiperSlide>
										<div className="cb_item flex_set">
											<div className="cb_box flex_box"><a id="cb_pop01" className="btn_popup cb_01">i寶貝智慧<br />聲控服務</a></div>
											<div className="cb_box flex_box"><a id="cb_pop40" className="btn_popup cb_40">聲控兌品</a></div>
											<div className="cb_box flex_box"><a id="cb_pop41" className="btn_popup cb_41">本月新星</a></div>
											<div className="cb_box flex_box"><a id="cb_pop03" className="btn_popup cb_03">我要說悄悄話</a></div>
											<div className="cb_box flex_box"><a id="cb_pop37" className="btn_popup cb_37">整點報時</a></div>
											<div className="cb_box flex_box"><a id="cb_pop36" className="btn_popup cb_36">日程表</a></div>
										</div>
										<div className="cb_dialog">
											<ul>
												<li className="flex_set cb_01"><p className="flex_box"><span>i寶貝，明天台北天氣如何?</span></p></li>
												<li className="flex_set cb_01"><p className="flex_box"><span>i寶貝，1-2+3-4+5等於多少?</span></p></li>
												<li className="flex_set cb_01"><p className="flex_box"><span>i寶貝，除夕是幾月幾號?</span></p></li>
												<li className="flex_set cb_40"><p className="flex_box"><span>i寶貝，召喚兌品小幫手。</span></p></li>
												<li className="flex_set cb_40"><p className="flex_box"><span>i寶貝，召喚商品兌換小幫手。</span></p></li>
												<li className="flex_set cb_41"><p className="flex_box"><span>i寶貝，召喚本月新星。</span></p></li>
												<li className="flex_set cb_41"><p className="flex_box"><span>i寶貝，最近有什麼新功能?</span></p></li>
											</ul>
											<ul>
												<li className="flex_set cb_41"><p className="flex_box"><span>i寶貝，[新功能名稱]是什麼?</span></p></li>
												<li className="flex_set cb_03"><p className="flex_box"><span>i寶貝，我要說悄悄話。</span></p></li>
												<li className="flex_set cb_37"><p className="flex_box"><span>提供整點報時資訊(於指定時間播放「現在時間X點整」)</span></p></li>
												<li className="flex_set cb_36"><p className="flex_box"><span>i寶貝，我明天有哪些鬧鐘?</span></p></li>
												<li className="flex_set cb_36"><p className="flex_box"><span>i寶貝，提醒我明天早上10點拿乾洗衣物。</span></p></li>
												<li className="flex_set cb_36"><p className="flex_box"><span>i寶貝，今天我有哪些待辦事項?</span></p></li>
											</ul>
										</div>
									</SwiperSlide>
									<SwiperSlide>
										<div className="cb_item flex_set">
											<div className="cb_box flex_box"><a id="cb_pop11" className="btn_popup cb_11">說笑話達人</a></div>
											<div className="cb_box flex_box"><a id="cb_pop15" className="btn_popup cb_15">匯率查詢</a></div>
											<div className="cb_box flex_box"><a id="cb_pop08" className="btn_popup cb_08">天氣小幫手</a></div>
											<div className="cb_box flex_box"><a id="cb_pop09" className="btn_popup cb_09">時間小幫手</a></div>
											<div className="cb_box flex_box"><a id="cb_pop10" className="btn_popup cb_10">算數小幫手</a></div>
											<div className="cb_box flex_box"><a id="cb_pop12" className="btn_popup cb_12">1288</a></div>
											<div className="cb_box flex_box"><a id="cb_pop13" className="btn_popup cb_13">維基百科</a></div>
										</div>
										<div className="cb_dialog">
											<ul>
												<li className="flex_set cb_11"><p className="flex_box"><span>i寶貝，我要聽笑話。</span></p></li>
												<li className="flex_set cb_11"><p className="flex_box"><span>i寶貝，說個笑話來聽聽。</span></p></li>
												<li className="flex_set cb_15"><p className="flex_box"><span>i寶貝，美金現在匯率多少?</span></p></li>
												<li className="flex_set cb_15"><p className="flex_box"><span>i寶貝，1元日幣可以換多少台幣?</span></p></li>
												<li className="flex_set cb_08"><p className="flex_box"><span>i寶貝，淡水今天要擦防曬乳嗎?</span></p></li>
												<li className="flex_set cb_08"><p className="flex_box"><span>i寶貝，台中今天的空氣品質。</span></p></li>
												<li className="flex_set cb_08"><p className="flex_box"><span>i寶貝，明天台東有放颱風假嗎?</span></p></li>
											</ul>
											<ul>
												<li className="flex_set cb_09"><p className="flex_box"><span>i寶貝，紐約和台北時差幾小時?</span></p></li>
												<li className="flex_set cb_09"><p className="flex_box"><span>i寶貝，多倫多現在幾點?</span></p></li>
												<li className="flex_set cb_09"><p className="flex_box"><span>i寶貝，今天是農曆幾月幾號?</span></p></li>
												<li className="flex_set cb_09"><p className="flex_box"><span>i寶貝，情人節是什麼時候?</span></p></li>
												<li className="flex_set cb_10"><p className="flex_box"><span>i寶貝，1+2x3等於多少?</span></p></li>
												<li className="flex_set cb_12"><p className="flex_box"><span>i寶貝，幫我找101附近的餐廳。</span></p></li>
												<li className="flex_set cb_13"><p className="flex_box"><span>i寶貝，周杰倫是誰?</span></p></li>
											</ul>
										</div>
									</SwiperSlide>
									<SwiperSlide>
										<div className="cb_item flex_set">
											<div className="cb_box flex_box"><a id="cb_pop14" className="btn_popup cb_14">三竹股市</a></div>
											<div className="cb_box flex_box"><a id="cb_pop18" className="btn_popup cb_18">查高鐵</a></div>
											<div className="cb_box flex_box"><a id="cb_pop17" className="btn_popup cb_17">HiNet生活誌</a></div>
											<div className="cb_box flex_box"><a id="cb_pop33" className="btn_popup cb_33">台語字典</a></div>
										</div>
										<div className="cb_dialog">
											<ul>
												<li className="flex_set cb_14"><p className="flex_box"><span>i寶貝，合作金庫股價多少?</span></p></li>
												<li className="flex_set cb_14"><p className="flex_box"><span>i寶貝，2412現在漲還是跌</span></p></li>
												<li className="flex_set cb_18"><p className="flex_box"><span>i寶貝，我要查高鐵。</span></p></li>
											</ul>
											<ul>
	
												<li className="flex_set cb_33"><p className="flex_box"><span>i寶貝，冷氣的台語</span></p></li>
												<li className="flex_set cb_33"><p className="flex_box"><span>i寶貝，長頸鹿台語怎麼說 </span></p></li>
											</ul>
										</div>
									</SwiperSlide>
								</Swiper>
							</div>
						</div>
					</div>
				</div>
				<div className="btn_main btn_other">
					<a href="/container/hamimall" target="_blank">聲控兌品專區</a>
				</div>
			</div>
		</>
	)
}

export default Caption01;